export default "__VITE_ASSET__BXlvsrnE__"